import { render, staticRenderFns } from "./BaseVisitProfile.vue?vue&type=template&id=44fe8a9a&"
import script from "./BaseVisitProfile.vue?vue&type=script&lang=js&"
export * from "./BaseVisitProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports